import "./homepage.css";
import React from "react";

function Homepage() {
  return (
    <div className="homepage-content" id='main'>
      <h1 spellCheck="false">LEVEL UP GAMING<br/>Sonipat</h1>
      <div className="slogan">
        Best Gaming Experience in Sonipat!
      </div>
    </div>
  );
}

export default Homepage;
